import { makeStyles } from '@material-ui/core/styles';
import getBrand from '../../utils/getBrand';

const isCelebrity = getBrand()?.id === 'cel';

const useStyles = makeStyles((Theme) => ({
  rootSearchTabs: {
    alignSelf: 'center',
    maxWidth: '1080px',
    width: '100%',
    backgroundColor: Theme.palette.white,
    borderRadius: `${isCelebrity ? '0' : '4px'}`,
    position: 'relative',
    minHeight: '200px',

    '& .MuiTabs-fixed': {
      boxShadow: '0 2px 4px 0 rgb(53 54 55 / 15%) ',
    },

    '& .MuiTabs-flexContainer': {
      backgroundColor: Theme.palette.white,
      paddingTop: '40px',
      alignItems: 'flex-end',
      '& button': {
        [Theme.breakpoints.down('sm')]: {
          height: '48px',
          boxSizing: 'content-box',
          padding: '8px 12px',
        },
      },
      '& button:first-child': {
        marginLeft: '24px',
        [Theme.breakpoints.up('md')]: {
          marginLeft: '40px',
        },
      },
      '& button:last-child': {
        marginRight: '24px',
        [Theme.breakpoints.up('md')]: {
          marginRight: '40px',
        },
      },
    },

    '& button.MuiTab-root': {
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[3],
      color: Theme.palette.primary.main,
      backgroundColor: Theme.palette.white,
      maxWidth: 'none',
      flex: 2,
      opacity: 1,
      lineHeight: '150%',
      padding: '16px 30px',
      borderBottom: `1px solid ${Theme.palette.border.divider}`,
      borderRadius: `${isCelebrity ? '0' : '8px 8px 0 0'}`,
      height: '30px',

      [Theme.breakpoints.down('md')]: {
        fontSize: Theme.typography.size[2],
      },
      [Theme.breakpoints.down('xs')]: {
        lineHeight: '125%',
        padding: '16px 20px',
      },

      '& span': {
        textTransform: 'none',
      },
    },

    '& button.Mui-selected': {
      fontFamily: Theme.typography.base.semiBold,
      color: Theme.palette.text.brand,
      backgroundColor: Theme.palette.surface.brand,
      borderBottom: `2px solid ${Theme.palette.primary.main}`,
    },

    '& .MuiTabs-scroller': {
      '& 	.MuiTabs-indicator': {
        backgroundColor: 'transparent',
      },
    },
  },

  tabPanel: {
    boxShadow: '0px 2px 4px 0px rgb(53 54 55 / 15%)',
    borderRadius: `${isCelebrity ? '0' : '4px'}`,
    '& .MuiInput-formControl, & .MuiOutlinedInput-root, & .MuiBox-root': {
      borderRadius: `${isCelebrity ? '1px' : '4px'}`,
      borderColor: Theme.palette.gray[850],
    },
  },
}));

export default useStyles;
